import email from './icons/email.svg';
import gif404 from './icons/dribbble_1.gif';
import product from './icons/product.jpg'

const Assets = {
    emailIcon: email,
    gift404: gif404,
    product: product,
}

export default Assets;